import {
  AttributionDetails,
  BasketMobile,
  ChargeAmount,
  ElectricityQuoteRequirement,
  EnergyBasketFragment,
  EnergyProductDetails,
  GasQuoteRequirement,
  Product,
  Quote,
  QuoteRequirement,
  QuoteStatus,
} from '@generated/gql/graphql';

import { BroadbandBasketData } from './broadband';
import {
  BoilerInsuranceBasketData,
  IncomeProtectorInsuranceBasketData,
} from './insurance';

interface EnergyProduct extends Product {
  details: EnergyProductDetails;
}

interface EnergyRequirement extends QuoteRequirement {
  requirement: ElectricityQuoteRequirement | GasQuoteRequirement;
}

interface EnergyQuote extends Quote {
  product: EnergyProduct;
  requirements: EnergyRequirement[];
}

interface InsuranceBasketData {
  boilerInsurance: BoilerInsuranceBasketData;
  incomeProtector: IncomeProtectorInsuranceBasketData;
  available: boolean;
  selected: boolean;
  monthlyCost: ChargeAmount;
  discount: BundleServiceDiscount;
}

interface CashbackBasketData {
  available: boolean;
  selected: boolean;
  monthlyCost: ChargeAmount;
  discount: BundleServiceDiscount;
}

interface BasketStatus {
  isValidSelection: boolean;
  unavailableStatuses: QuoteStatus[];
}

interface BundleBasketData {
  attributionDetails: Nullable<AttributionDetails>;
  basketStatus: BasketStatus;
  broadband: BroadbandBasketData;
  cashback: CashbackBasketData;
  createdAt: string;
  depositRequired: boolean;
  energy: Nullable<EnergyBasketFragment>;
  hasExpiredBundle: boolean;
  hasSmartmeter: boolean;
  id: string;
  insurance: InsuranceBasketData;
  isHomeOwner: boolean;
  mobile: Nullable<BasketMobile>;
  monthlyCost: ChargeAmount;
  willCreditCheck: boolean;
}

type BundleServiceDiscount = {
  price: ChargeAmount;
  durationMonths: number;
} | null;

interface SelectedServices {
  broadband: boolean;
  energy: boolean;
  mobile: boolean;
  insurance: boolean;
  cashback: boolean;
}

enum UpdatedTariffModalVariant {
  initial = 'initial',
  productRemoved = 'productRemoved',
  productAdded = 'productAdded',
  bundleExpired = 'bundleExpired',
  priceDecreased = 'priceDecreased',
  priceIncreased = 'priceIncreased',
}

enum OutdatedBundleModalVariant {
  none = 'none',
  productsUnavailable = 'productsUnavailable',
  productsChanged = 'productsChanged',
}

export type {
  EnergyQuote,
  BroadbandBasketData,
  BundleBasketData,
  SelectedServices,
  BundleServiceDiscount,
};

export { UpdatedTariffModalVariant, OutdatedBundleModalVariant };
